import React, {useState, useEffect} from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import CaregiverUpdateForm from "./CaregiverUpdateForm";
import { SIREN_CONFIG } from 'config.js';
import {useSelector} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));


const CaregiverUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const [caregiverInfo, setCaregiverInfo] = useState(null);
  const facility_id = useSelector((store) => store.user.facility_id);


  const loadData = (caregiverId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/caregiver/caregiverInfo?facility_id=${facility_id}&caregiver_id=${caregiverId}`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {

      if (snapshot.resultData){
        setCaregiverInfo({
          caregiverId: snapshot.resultData.caregiverId,
          caregiverName: snapshot.resultData.caregiverName,
          caregiverTelNo: snapshot.resultData.caregiverTelNo,
          alarmStartTime : snapshot.resultData.alarmStartTime,
          alarmEndTime : snapshot.resultData.alarmEndTime,
        });
      }
    }
    );
  }


  useEffect( () => {
    loadData(match.params.caregiverId);
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { caregiverInfo && <CaregiverUpdateForm caregiverInfo={caregiverInfo} history={history} /> }
      </div>
    </div>
  );
};


CaregiverUpdate.propTypes = {
  history: PropTypes.object
};

export default CaregiverUpdate;
